var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.65 5.41978C14.2 2.34095 11.25 0.410156 8 0.410156C4.75 0.410156 1.8 2.34095 0.35 5.41978C0.3 5.57633 0.3 5.73288 0.35 5.88943C1.8 8.91608 4.75 10.8469 8 10.8469C11.25 10.8469 14.2 8.91608 15.65 5.83725C15.7 5.73288 15.7 5.52415 15.65 5.41978ZM8 9.8032C5.2 9.8032 2.7 8.18551 1.4 5.62852C2.7 3.07152 5.2 1.45383 8 1.45383C10.8 1.45383 13.3 3.07152 14.6 5.62852C13.3 8.18551 10.8 9.8032 8 9.8032ZM8 2.4975C6.35 2.4975 5 3.90646 5 5.62852C5 7.35057 6.35 8.75953 8 8.75953C9.65 8.75953 11 7.35057 11 5.62852C11 3.90646 9.65 2.4975 8 2.4975ZM8 7.71586C6.9 7.71586 6 6.77656 6 5.62852C6 4.48048 6.9 3.54117 8 3.54117C9.1 3.54117 10 4.48048 10 5.62852C10 6.77656 9.1 7.71586 8 7.71586Z",
    fill: "#525559"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisit);
export default __webpack_public_path__ + "static/media/visit.5abc8c453dadc76ffc5bb2641f9b74da.svg";
export { ForwardRef as ReactComponent };